<template>
  <div class="cbox">
    <div style="margin: 0px auto;">
      <div style="width:65%;min-width:290px;margin: 0 auto;">
        <div class="h">
          <span class="fl text">门店编号：</span>
          <el-input class="dis" :disabled="true" v-model.trim="user.storecode">
          </el-input>
        </div>
        <div class="h">
          <span class="fl text">门店名称：</span>
          <el-input class="dis" :disabled="true" placeholder="请输入内容" v-model.trim="user.storename">
          </el-input>
        </div>
        <div class="h">
          <span class="fl text">营业许可证：</span>
          <el-input class="dis" :disabled="true" placeholder="请输入内容" v-model.trim="user.busilicense">>>
          </el-input>
        </div>
        <div class="h">
          <span class="fl text">邮箱1：</span>
          <el-input class="dis" :disabled="true" placeholder="请输入内容" v-model.trim="user.email">>
          </el-input>
        </div>
        <div class="h">
          <span class="fl text">门店用户编号：</span>
          <el-input class="dis" :disabled="true" placeholder="请输入内容" v-model.trim="user.user_code">
          </el-input>
        </div>
        <div class="h">
          <span class="fl text">门店用户名称：</span>
          <el-input class="dis" :disabled="true" v-model.trim="user.user_name" clearable>
          </el-input>
        </div>
      </div>
      <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm my user" style="width:65%;min-width:290px;margin: 0 auto;">
        <el-form-item label="原始密码：" prop="oldpass" class="passlabel">
          <el-input type="password" v-model="ruleForm2.oldpass" auto-complete="off" style="margin-left: 13px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="pass" class="passlabel">
          <el-input type="password" v-model="ruleForm2.pass" auto-complete="off" style="margin-left: 13px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="checkPass" class="passlabel">
          <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" style="margin-left: 13px;" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm2')" class="fr">确认提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 弹窗 start --> 
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel> 
  </div>
</template>
<script>
/*引入公共方法*/
// import { setCookie, getCookie, delCookie } from '../../static/js/cookie.js' 
export default {
  data() {
    var validateOldPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入原始密码'));
      } else if (value.length < 6) {
        callback(new Error('密码不能小于6位'));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 6) {
        callback(new Error('密码不能小于6位'));
      } else {
        if (this.ruleForm2.checkPass !== '') {
          this.$refs.ruleForm2.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm2.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      flag:false,
      msgShow:false,
      modelFlag:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'', 
      butmsg:'确认', 
      butmsg2:'确认', 
      methodName:'',
      utilpath: '',
      user: {},
      ruleForm2: {
        oldpass: '',
        pass: '',
        checkPass: ''
      },
      rules2: {
        oldpass: [
          { validator: validateOldPass, trigger: 'blur' }
        ],
        pass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.utilpath = this.axios.defaults.baseURL;
    this.init();
  },
  methods: {
    returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
           //  console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='savePassw'){
              this.fullscreenLoading=true;
                var reqparams={
                  userCode:this.user.user_code,  
                  oldpassWord: this.ruleForm2.oldpass,
                  password: this.ruleForm2.checkPass,
                }
              //  console.log("---参数！！！----"+JSON.stringify(this.reqparams)); 
                this.$http.post(this.utilpath+'/updateUser',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{ 
                  this.fullscreenLoading=false;
                    if(res.data.status == '0'){
                         this.$message({
                          showClose:true,
                          message:'修改成功',
                          type:'succcess'
                        });
                         this.ruleForm2= {
                          oldpass: '',
                          pass: '',
                          checkPass: ''
                        };
                        this.msgShow =false;
                    }else if(res.data.status == '-1'){
                        this.modelFlag = true;
                        this.msgShow = false;
                        this.methodName = 'message';
                        this.msg = '原始密码有误，请重新输入';
                        this.butflag =false;
                        this.butmsg='知道了';
                    }else{
                       this.modelFlag = true;
                       this.msgShow = true;
                        this.methodName = 'message';
                        this.msg = res.data.message;
                        this.butflag =false;
                        this.butmsg='知道了';
                    }
                }, (err) => {
                  this.fullscreenLoading=false;
                      this.modelFlag = true;
                      this.msgShow =false;
                      this.methodName = 'message';
                      this.msg = '连接提交接口失败'+err;
                      this.butflag =false;
                      this.butmsg='知道了';
                    console.log(err);
                })
            }else if(this.methodName =='---'){
                this.$http.post(this.utilpath+'/updateUserPassw',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{ 
                    if(res.data.status == '0'){
                         this.$message({
                          showClose:true,
                          message:'修改成功',
                          type:'succcess'
                        })
                         this.msgShow =false;
                    }else{
                        this.modelFlag = true;
                        this.msgShow = true;
                        this.methodName = 'message';
                        this.msg = res.data.message;
                        this.butflag =false;
                        this.butmsg='知道了';
                    }
                }, (err) => {
                  this.msgShow =false;
                      this.modelFlag = true;
                      this.methodName = 'message';
                      this.msg = '连接修改密码接口失败'+err;
                      this.butflag =false;
                      this.butmsg='知道了';
                    console.log(err);
                })
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'info'
        })
      }
    }, 
    returnMsg2(flag){ 
      this.modelFlag = false;
      if(flag){
           //  console.log("---进来了！！！----"+this.methodName);
            if(this.methodName ==''){
                
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    }, 
    init() {
      var user = {
        pk_dept: '部门',
        storecode: 'm001',
        storename: '门店一',
        busilicense: '',
        email: '',
        user_code: '001',
        user_name: "卡卡",
        coutstockorgid: '',
        amount: 8888,
        Surplus: 6666
      };
    //  console.log("set打印vuex1：" + JSON.stringify(this.$store.state.userInfo));
      this.$store.commit('SWITCHSHOW', user);
    //  console.log("set打印vuex2：" + JSON.stringify(this.$store.state.userInfo));
      this.user = JSON.parse(window.localStorage.getItem("userInfo"));
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) { 
            this.methodName = 'savePassw';
            this.modelFlag = true;
            this.msgShow =false;
            this.butflag =true;
            this.butmsg='确认';
            this.msg = '确定修改登录密码？';
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submit() {
      let userid = getCookie('userid');
      let reqParams = {
        user_code: this.user.user_code,
        OldPassword: this.ruleForm2.oldpass,
        newPassword: this.ruleForm2.pass
      }
      this.$http.post(this.utilpath + '/updateUser', reqParams, { emulateJSON: true,_timeout:600 })
        // this.$http.post('ktnapi/users', reqParams,{emulateJSON:true})
        .then((res) => {
        //  console.log("打印结果："+JSON.stringify(res.data));
          var status = res.data.status;
          if (status == '0') {
            this.$message({
              showClose: true,
              message: '修改成功！',
              type: 'success'
            });
            this.msgShow =false;
          }else if (status == '1') {
            this.methodName = 'savePassw';
            this.modelFlag = true;
            this.butflag =false;
            this.msgShow =false;
            this.butmsg='知道了';
            this.msg = '原始密码有误，请重新输入';
            this.ruleForm2= {
              oldpass: '',
              pass: '',
              checkPass: ''
            };
          }else{
            this.methodName = 'savePassw';
            this.modelFlag = true;
            this.msgShow = true;
            this.butflag =false;
            this.butmsg='知道了';
            this.msg = res.data.message;
          }
        }, (err) => {
          this.$message({
            showClose: true,
            message: '修改失败！',
            type: 'error'
          });
        });
    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/settinguser.vue